import _ from "lodash";
import h from "../../core/createElement";
import file_service from "../../service/file_service";
import { switchable_element } from "../../utils"
import FileCard from "../file_card";
import GenericConfirmModal from "../../modals/generic_confirm";
import popupAlerts from "../../core/popupAlerts";
import SimpleFileCard from "../simple_file_card";
import Pagination from "../pagination";
import Spinner from "../spinner";
import EmptyMsgBox from "../empty_msg";

export default function FileList({ shared = {}, 'hide-card-btns': hide_card_btns = false, cardClick, name = "file_list" }) {
    let page = 1, search = {};

    const
        empMsg = <EmptyMsgBox text="Nenhum arquivo encontrado!" />,
        loading = switchable_element(<Spinner />),
        list = switchable_element(h("section", { class: 'full-size' }, empMsg));

    const
        fetch_files = async (_search, _page, not_show_by_ids = []) => {
            try {
                loading.show();

                if (_page) page = _page;
                if (_search) search = _search;

                const { data } = await file_service.get({ ...search, page, group_id: shared.group_id });

                if (not_show_by_ids.length) data.data = _.filter(data.data, e => !not_show_by_ids.includes(e.id));

                fill_data(data);

                loading.hide()
            } catch (e) {
                loading.hide()
            }
        },
        delete_file = (item) => {
            GenericConfirmModal.show({
                title: "Deletar Arquivo",
                text: `Deseja realmente apagar ${item.name} ?`,
                confirm: async () => {
                    try {
                        loading.show();

                        await file_service.delete(item.id);

                        popupAlerts.success("Arquivo apagado com sucesso!");

                        fetch_files();
                    } catch (e) {
                        loading.hide();
                    };
                }
            });
        },
        update_file = (item, file) => {
            GenericConfirmModal.show({
                title: "Atualizar Arquivo",
                text: `Deseja realmente atualizar ${item.name} ?`,
                confirm: async () => {
                    const progress_bar = popupAlerts.progress('Fazendo upload...');

                    try {
                        const body = new FormData();

                        body.append('jrxml', file);

                        const progress_callback = (evt) => {
                            progress_bar.progress((evt.loaded / evt.total) * 100)
                        };

                        await file_service.update_file(body, progress_callback, item.id);

                        progress_bar.dismiss();

                        popupAlerts.success('Upload concluido!');

                        await fetch_files();
                    } catch (e) {
                        progress_bar.dismiss()
                    };
                }
            });
        },
        fill_data = ({ data = [], current_page = 1, total_pages = 1 } = {}) => {
            const Card = hide_card_btns ? SimpleFileCard : FileCard;

            requestAnimationFrame(() => {
                list.switch(
                    <section class="full-size">
                        {data.length ?
                            _.map(data, e => <Card data={e} delete_file={delete_file} update_file={update_file} onClick={o => cardClick && cardClick(o)} />)
                            :
                            empMsg
                        }
                        <section class="float-pagination">
                            <Pagination current={current_page} last={total_pages} callback={(e) => fetch_files(null, e.page)} />
                        </section>
                    </section>
                );
            });
        };

    shared[name] = {
        fetch_files,
        clean_file_list: () => fill_data()
    };

    return [list.current(), loading.marker()];
};